import React from 'react';
import { useContactForm } from '../../hooks/useContactForm';
import FormInput from './FormInput';
import FormSelect from './FormSelect';
import FormStatus from './FormStatus';
import SubmitButton from './SubmitButton';

const ContactForm: React.FC = () => {
  const { formData, formStatus, handleInputChange, handleSubmit } = useContactForm();

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid grid-cols-2 gap-4">
        <FormInput
          name="lastName"
          value={formData.lastName}
          onChange={handleInputChange}
          placeholder="Nom"
          required
        />
        <FormInput
          name="firstName"
          value={formData.firstName}
          onChange={handleInputChange}
          placeholder="Prénom"
          required
        />
      </div>
      
      <FormInput
        type="email"
        name="email"
        value={formData.email}
        onChange={handleInputChange}
        placeholder="Email"
        required
      />
      
      <FormInput
        type="tel"
        name="phone"
        value={formData.phone}
        onChange={handleInputChange}
        placeholder="Téléphone"
        required
      />
      
      <FormSelect
        name="projectType"
        value={formData.projectType}
        onChange={handleInputChange}
        required
        options={[
          { value: '', label: 'Type de projet' },
          { value: 'isolation', label: 'Isolation' },
          { value: 'chauffage', label: 'Chauffage' },
          { value: 'eclairage', label: 'Éclairage' },
          { value: 'autre', label: 'Autre' }
        ]}
      />
      
      <FormInput
        as="textarea"
        name="message"
        value={formData.message}
        onChange={handleInputChange}
        placeholder="Message"
        required
        rows={4}
      />
      
      <SubmitButton status={formStatus} />
      <FormStatus status={formStatus} />
    </form>
  );
};

export default ContactForm;